import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/azet-logo-horizontal-white.png";
import logoCollapsed from "../../../assets/azet-logo-no-text-white.png";

export default ({ collapsed }) => {
  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div>
          <h3>
            <Link to="/app/home">
              <img src={logoCollapsed} alt="Azet logo" width={50} />
            </Link>
          </h3>
        </div>
      ) : (
        <h3>
          <Link to="/app/home">
            <img src={logo} alt="Azet logo" width={160} />
          </Link>
        </h3>
      )}
    </div>
  );
};
